/**
 * Public RSVP API Client
 * Accountless Jamaat-wide RSVP flow.
 */

import { apiCall } from '../api';
import type {
  PublicRSVPEventResponse,
  PublicRSVPEligibilityResponse,
  PublicRSVPLookupResponse,
  PublicRSVPManageResponse,
  PublicRSVPRequest,
  PublicRSVPSubmitResponse,
  PublicRSVPUpdateRequest,
} from '@/types/api';

export async function fetchPublicRSVPEvent(slug: string): Promise<PublicRSVPEventResponse> {
  return apiCall<PublicRSVPEventResponse>(`/api/public-rsvp/events/${slug}`, {
    method: 'GET',
  });
}

export async function checkPublicRSVPEligibility(
  slug: string,
  itsId: string
): Promise<PublicRSVPEligibilityResponse> {
  return apiCall<PublicRSVPEligibilityResponse>(`/api/public-rsvp/events/${slug}/eligibility`, {
    method: 'POST',
    body: JSON.stringify({ itsId }),
  });
}

export async function submitPublicRSVP(
  slug: string,
  data: PublicRSVPRequest
): Promise<PublicRSVPSubmitResponse> {
  return apiCall<PublicRSVPSubmitResponse>(`/api/public-rsvp/events/${slug}/rsvps`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function lookupPublicRSVP(
  slug: string,
  data: { itsId: string; phone: string }
): Promise<PublicRSVPLookupResponse | PublicRSVPEligibilityResponse> {
  return apiCall<PublicRSVPLookupResponse | PublicRSVPEligibilityResponse>(
    `/api/public-rsvp/events/${slug}/lookup`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    }
  );
}

export async function fetchPublicRSVPByToken(token: string): Promise<PublicRSVPManageResponse> {
  return apiCall<PublicRSVPManageResponse>(`/api/public-rsvp/rsvps/${token}`, {
    method: 'GET',
  });
}

export async function updatePublicRSVPByToken(
  token: string,
  data: PublicRSVPUpdateRequest
): Promise<Pick<PublicRSVPSubmitResponse, 'rsvp'>> {
  return apiCall<Pick<PublicRSVPSubmitResponse, 'rsvp'>>(`/api/public-rsvp/rsvps/${token}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function cancelPublicRSVPByToken(token: string): Promise<{ message: string }> {
  return apiCall<{ message: string }>(`/api/public-rsvp/rsvps/${token}/cancel`, {
    method: 'POST',
  });
}
